//
//
//
//
//
//
//
//
//

	export default{
		name:'search',
		data(){
			return{
				input_active:false,
				key:''
			}
		},
		methods:{
			focus(){
				this.input_active = true
			},
			blur(){
				this.input_active = false
			},
			
			tosearch(){
				if(this.key.trim() != ''){
					this.$emit('to_search',this.key)
				}else{
					// 弹框(请输入内容)
				}
				
			}
		},
		watch:{
			key(v){
				if(v.trim() == ''){
					this.$emit('to_search',this.key)
				}
			}
		}
	}
